var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'file')?_c('SelectSpacePath',_vm._g(_vm._b({},'SelectSpacePath',_vm.$attrs,false),_vm.$listeners)):_c('SelectStencilPath',_vm._g(_vm._b({},'SelectStencilPath',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }